import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function DawsonStory() {
  return <div className="w-full bg-zinc-900 py-24 relative overflow-hidden" data-id="element-200">
      {/* Animated background grid */}
      <div className="absolute inset-0 opacity-5 animate-grid-pulse" style={{
      backgroundImage: 'repeating-linear-gradient(0deg, #ffa500 0px, #ffa500 1px, transparent 1px, transparent 40px), repeating-linear-gradient(90deg, #ffa500 0px, #ffa500 1px, transparent 1px, transparent 40px)'
    }} data-id="element-201" />
      {/* Floating particles */}
      {[...Array(25)].map((_, i) => <div key={i} className="absolute rounded-full animate-float" style={{
      width: `${2 + Math.random() * 3}px`,
      height: `${2 + Math.random() * 3}px`,
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
      backgroundColor: i % 3 === 0 ? '#22c55e' : '#f59e0b',
      animationDelay: `${Math.random() * 5}s`,
      animationDuration: `${10 + Math.random() * 15}s`,
      opacity: 0.4
    }} data-id="element-202" />)}
      <div className="container mx-auto px-6 relative z-10" data-id="element-203">
        <div className="max-w-4xl mx-auto" data-id="element-204">
          {/* Header */}
          <div className="mb-12 animate-fade-in-up" data-id="element-205">
            <div className="inline-block border-4 border-amber-500 bg-black px-6 py-3 mb-6 shadow-[0_0_40px_rgba(255,165,0,0.4)] animate-glow-amber" data-id="element-206">
              <h2 className="text-4xl md:text-5xl font-bold text-amber-500 font-mono" data-id="element-207">
                WHY THIS EXISTS
              </h2>
            </div>
            <p className="text-green-400 text-xl font-mono animate-fade-in-up" style={{
            animationDelay: '0.2s'
          }} data-id="element-208">
              // DAWSON_SEWELL.TXT
            </p>
          </div>
          {/* Profile Section */}
          <div className="flex flex-col md:flex-row gap-8 mb-8" data-id="element-209">
            {/* Image */}
            <div className="flex-shrink-0 mx-auto md:mx-0 animate-fade-in-up group" style={{
            animationDelay: '0.3s'
          }} data-id="element-210">
              <div className="border-4 border-green-500 bg-black p-2 shadow-[0_0_30px_rgba(0,255,0,0.3)] hover:shadow-[0_0_50px_rgba(0,255,0,0.6)] transition-all duration-500 relative overflow-hidden" data-id="element-211">
                <div className="absolute inset-0 bg-gradient-to-br from-green-500/0 via-green-500/10 to-green-500/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-212" />
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-green-400 to-transparent transform -translate-x-full group-hover:translate-x-full transition-transform duration-1000" data-id="element-213" />
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oHqDuqnGHeawkRUGZK8oBm/angelofdeath.jpg" alt="Dawson Sewell" className="w-64 h-64 object-cover grayscale group-hover:grayscale-0 transition-all duration-500 relative z-10" data-id="element-214" />
                <div className="border-t-2 border-green-500 mt-2 pt-2 relative z-10" data-id="element-215">
                  <p className="text-green-400 font-mono text-xs text-center flex items-center justify-center gap-2" data-id="element-216">
                    <span className="w-2 h-2 bg-green-400 animate-pulse" data-id="element-217" />
                    {'>'} PERSONNEL_ID: DS-2024
                  </p>
                </div>
              </div>
            </div>
            {/* Quick Info Panel */}
            <div className="flex-grow border-4 border-amber-600 bg-black p-6 animate-fade-in-up hover:shadow-[0_0_40px_rgba(255,165,0,0.3)] transition-all duration-500 group relative overflow-hidden" style={{
            animationDelay: '0.4s'
          }} data-id="element-218">
              <div className="absolute inset-0 bg-gradient-to-r from-amber-950/0 via-amber-950/20 to-amber-950/0 transform -translate-x-full group-hover:translate-x-full transition-transform duration-1000" data-id="element-219" />
              <div className="border-b-2 border-amber-600 pb-3 mb-4 relative z-10" data-id="element-220">
                <p className="text-amber-500 font-mono text-sm flex items-center gap-2" data-id="element-221">
                  <span className="w-2 h-2 bg-amber-500 animate-pulse" data-id="element-222" />
                  {'>'} PROFILE_SUMMARY.DAT
                </p>
              </div>
              <div className="space-y-3 text-sm relative z-10" data-id="element-223">
                {[{
                label: 'NAME:',
                value: 'DAWSON SEWELL'
              }, {
                label: 'ROLE:',
                value: 'FOUNDER & AUTOMATION ARCHITECT'
              }, {
                label: 'EXPERIENCE:',
                value: '10+ YEARS AUTOMATION SYSTEMS'
              }, {
                label: 'SPECIALTY:',
                value: 'AI-POWERED WORKFLOW OPTIMIZATION'
              }].map((item, i) => <div key={i} className="flex gap-3 hover:translate-x-2 transition-transform duration-300" style={{
                animationDelay: `${0.5 + i * 0.1}s`
              }} data-id="element-224">
                    <span className="text-green-400 font-mono" data-id="element-225">
                      {item.label}
                    </span>
                    <span className="text-amber-100" data-id="element-226">{item.value}</span>
                  </div>)}
              </div>
            </div>
          </div>
          {/* Story content */}
          <div className="border-4 border-green-500 bg-black p-10 shadow-[0_0_50px_rgba(0,255,0,0.3)] animate-fade-in-up hover:shadow-[0_0_70px_rgba(0,255,0,0.5)] transition-all duration-500 relative overflow-hidden group" style={{
          animationDelay: '0.5s'
        }} data-id="element-227">
            <div className="absolute inset-0 opacity-5" data-id="element-228">
              <div className="absolute inset-0 bg-gradient-to-br from-green-500 via-transparent to-green-500 animate-pulse-slow" data-id="element-229" />
            </div>
            {/* Corner accents */}
            <div className="absolute top-2 left-2 w-8 h-8 border-t-2 border-l-2 border-green-400 animate-pulse" data-id="element-230" />
            <div className="absolute bottom-2 right-2 w-8 h-8 border-b-2 border-r-2 border-green-400 animate-pulse" style={{
            animationDelay: '0.5s'
          }} data-id="element-231" />
            <div className="space-y-6 text-amber-100 leading-relaxed relative z-10" data-id="element-232">
              <p className="text-lg group-hover:text-glow transition-all duration-300" data-id="element-233">
                I spent a decade building automation systems for companies that
                didn't need them.
              </p>
              <p data-id="element-234">
                They'd ask for features. I'd build them. Everyone would
                celebrate the launch. Six months later, nobody was using it. Or
                worse—it worked perfectly but didn't change anything that
                mattered.
              </p>
              <p data-id="element-235">
                The problem wasn't the code. It was that{' '}
                <span className="text-amber-500 font-semibold" data-id="element-236">
                  nobody challenged the requirement in the first place
                </span>
                .
              </p>
              <div className="border-l-4 border-amber-500 pl-6 py-4 bg-amber-950/20 my-8 hover:bg-amber-950/30 transition-colors duration-300 relative group/quote" data-id="element-237">
                <div className="absolute left-0 top-0 bottom-0 w-1 bg-amber-400 transform scale-y-0 group-hover/quote:scale-y-100 transition-transform duration-500" data-id="element-238" />
                <p className="text-amber-300 text-lg italic" data-id="element-239">
                  "Success is comfortable. Comfort is slow. The uncomfortable
                  path is usually the profitable one."
                </p>
              </div>
              <p data-id="element-240">
                So I started saying no. Not to be difficult—to be useful. I
                started asking uncomfortable questions:
              </p>
              <ul className="space-y-3 pl-6" data-id="element-241">
                {['What decision will this help you make?', 'Why does this process exist?', 'What happens if we just delete this step?', 'How will we measure if this worked?'].map((question, i) => <li key={i} className="flex items-start gap-3 hover:translate-x-2 transition-transform duration-300" style={{
                animationDelay: `${0.6 + i * 0.1}s`
              }} data-id="element-242">
                    <span className="text-green-400 mt-1 animate-pulse" data-id="element-243">
                      {'>'}
                    </span>
                    <span data-id="element-244">{question}</span>
                  </li>)}
              </ul>
              <p data-id="element-245">
                Most clients hated it at first. Then they saw the results.
                Projects that used to take 6 months shipped in 3 weeks. Systems
                that used to require 3 full-time people to maintain ran
                themselves. Processes that used to have 12 steps had 3.
              </p>
              <p data-id="element-246">
                The algorithm emerged from that work:{' '}
                <span className="text-green-400 font-mono" data-id="element-247">
                  Challenge everything
                </span>{' '}
                before you build.
                <span className="text-amber-500 font-mono" data-id="element-248">
                  {' '}
                  Delete ruthlessly
                </span>
                —if you don't restore at least 10% of time, you weren't bold
                enough.
                <span className="text-green-400 font-mono" data-id="element-249"> Simplify</span> what
                survives.
                <span className="text-amber-500 font-mono" data-id="element-250">
                  {' '}
                  Accelerate
                </span>{' '}
                delivery. Only then{' '}
                <span className="text-green-400 font-mono" data-id="element-251">automate</span>.
              </p>
              <p className="text-lg" data-id="element-252">
                Dilbert Ratio Group exists because most automation projects
                fail—not because of bad technology, but because they automate
                the wrong things. We fix that.
              </p>
            </div>
          </div>
          {/* Contact prompt */}
          <div className="mt-12 border-4 border-amber-600 bg-black p-8 text-center animate-fade-in-up hover:shadow-[0_0_40px_rgba(255,165,0,0.4)] transition-all duration-500 group relative overflow-hidden" style={{
          animationDelay: '0.7s'
        }} data-id="element-253">
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-amber-500/10 to-transparent transform -translate-x-full group-hover:translate-x-full transition-transform duration-1000" data-id="element-254" />
            <p className="text-amber-100 text-lg mb-6 relative z-10" data-id="element-255">
              Want to talk about your automation challenge?
            </p>
            <a href="https://www.linkedin.com/in/dawsonsewell" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-amber-600 hover:bg-amber-500 text-black font-bold py-4 px-8 transition-all duration-300 border-4 border-amber-400 shadow-[0_0_30px_rgba(255,165,0,0.6)] hover:shadow-[0_0_50px_rgba(255,165,0,0.9)] group/btn text-lg relative z-10 animate-pulse-cta hover:scale-105" data-id="element-256">
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -translate-x-full group-hover/btn:translate-x-full transition-transform duration-1000" data-id="element-257" />
              <span className="tracking-wider relative z-10" data-id="element-258">
                CONNECT ON LINKEDIN
              </span>
              <ArrowRightIcon className="w-5 h-5 group-hover/btn:translate-x-2 transition-transform duration-300 relative z-10" data-id="element-259" />
            </a>
          </div>
        </div>
      </div>
      <style data-id="element-260">{`
        @keyframes grid-pulse {
          0%, 100% { opacity: 0.05; }
          50% { opacity: 0.1; }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0) translateX(0) rotate(0deg); }
          50% { transform: translateY(-120px) translateX(60px) rotate(180deg); }
        }
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes glow-amber {
          0%, 100% { box-shadow: 0 0 40px rgba(255, 165, 0, 0.4); }
          50% { box-shadow: 0 0 60px rgba(255, 165, 0, 0.7); }
        }
        @keyframes pulse-slow {
          0%, 100% { opacity: 0.05; }
          50% { opacity: 0.15; }
        }
        .animate-grid-pulse {
          animation: grid-pulse 4s ease-in-out infinite;
        }
        .animate-float {
          animation: float linear infinite;
        }
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
          opacity: 0;
        }
        .animate-glow-amber {
          animation: glow-amber 3s ease-in-out infinite;
        }
        .animate-pulse-slow {
          animation: pulse-slow 4s ease-in-out infinite;
        }
        .text-glow {
          text-shadow: 0 0 20px currentColor;
        }
      `}</style>
    </div>;
}